import { BaseAudioRecordingAppEventOperation } from "./BaseAudioRecordingAppEventOperation";
import { AudioRecordingAppEventOperationKind } from "@/store/sync/operations/types";

export class MarkVoiceDisconnectedAudioRecordingOperation extends BaseAudioRecordingAppEventOperation {
  get operationKind(): AudioRecordingAppEventOperationKind {
    return "MARK_VOICE_DISCONNECTED_AUDIO_RECORDING";
  }

  // Voice disconnect doesn't change model status fields
  // The event is tracked for observability purposes
}
